export const testimonialText =
  '"Our response rate is under a minute right now. We’re able to drive a sale without having to speak on the phone."';

export const testimonialAttribution =
  "Zahadia Ortiz-Ceballos | Adam's Pest Control";
